import type {
  ISiteAssignment,
  ISiteAssignmentData,
  ICustomerSiteAssignment,
  ICustomerSiteAssignmentData
} from '.'
import { AbstractModel } from '../base'
import { Client, Site, type IClient, type ISite } from '../client'

export class SiteAssignment extends AbstractModel implements ISiteAssignment {
  readonly id?: number
  readonly is_site_approver: boolean
  readonly site: ISite

  constructor(data: ISiteAssignmentData) {
    super()

    // Validate data
    const requiredFields: (keyof ISiteAssignmentData)[] = ['is_site_approver', 'site']
    this.validate(data, requiredFields)

    this.is_site_approver = data.is_site_approver!
    this.site = new Site(data.site!)

    if (data.id) {
      this.id = data.id
    }
  }

  toString() {
    return this.site.toString()
  }
}

export class CustomerSiteAssignment extends AbstractModel implements ICustomerSiteAssignment {
  readonly id?: number
  readonly site: ISite
  readonly client?: IClient

  constructor(data: ICustomerSiteAssignmentData) {
    super()

    // Validate data
    const requiredFields: (keyof ICustomerSiteAssignmentData)[] = ['site']
    this.validate(data, requiredFields)

    this.site = new Site(data.site!)

    if (data.id) {
      this.id = data.id
    }

    if (data.client) {
      this.client = new Client(data.client!)
    }
  }

  toString() {
    return this.site.toString()
  }
}
